import React from 'react';
import { Check } from 'lucide-react';

interface Props {
  steps: string[];
  currentStep: number;
  primaryColor?: string;
  accentColor?: string;
}

// Horizontal step indicator used by the public Booking Widget.
export default function BookingStepper({ steps, currentStep, primaryColor, accentColor }: Props) {
  return (
    <div className="flex items-center w-full overflow-x-auto pb-2">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isComplete = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center min-w-[64px]">
              <div
                style={
                  isComplete
                    ? { backgroundColor: primaryColor, borderColor: primaryColor }
                    : isActive
                    ? { borderColor: accentColor, color: accentColor }
                    : undefined
                }
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 ${
                  isComplete
                    ? 'text-white'
                    : isActive
                    ? 'bg-white'
                    : 'border-slate-300 text-slate-400 bg-white'
                }`}
              >
                {isComplete ? <Check size={14} /> : stepNumber}
              </div>
              <span style={isActive ? { color: accentColor } : undefined} className={`mt-1 text-[11px] font-medium text-center ${!isActive ? 'text-strivre-mutedtext' : ''}`}>{label}</span>
            </div>
            {index < steps.length - 1 && (
              <div style={isComplete ? { backgroundColor: primaryColor } : undefined} className={`flex-1 h-0.5 mx-1 ${!isComplete ? 'bg-slate-200' : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
